module.exports = __webpack_public_path__ + "static/stqblogo-22d8dac2fed3993e96763c4134b07bce.svg";